import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import da from './locales/da.json';
import en from './locales/en.json';

const resources = {
  da: {
    translation: da
  },
  en: {
    translation: en
  }
};

// Detect language based on domain
const getLanguageFromDomain = (): string => {
  const hostname = window.location.hostname;

  // .com domain -> English
  if (hostname.endsWith('.com')) {
    return 'en';
  }

  // .dk domains -> Danish
  if (hostname.endsWith('.dk')) {
    return 'da';
  }

  // Default to Danish for localhost and other domains
  return 'da';
};

// Get initial language: domain takes priority over localStorage
const getInitialLanguage = (): string => {
  const domainLang = getLanguageFromDomain();

  // Check if user has manually changed language (stored in localStorage)
  const storedLang = localStorage.getItem('i18nextLng');

  // If user has manually selected a language, respect that choice
  // Otherwise use domain-based language
  if (storedLang && (storedLang === 'da' || storedLang === 'en')) {
    return storedLang;
  }

  return domainLang;
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'da',

    interpolation: {
      escapeValue: false // react already does escaping
    }
  });

export default i18n;
